/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     静态路由配置选项
  +--------------------------------------------------------------------------------------
*/

import TheLayout from "@/views/layout/TheLayout";

const staticRoutes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/common/Login"),
    meta: { frame: "Common", title: "登录" }
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("@/views/common/Register"),
    meta: { frame: "Common", title: "注册" }
  },
  {
    path: "/password",
    name: "Password",
    component: () => import("@/views/common/Password"),
    meta: { frame: "Common", title: "忘记密码" }
  },
  {
    path: "/refresh",
    name: "Refresh",
    component: () => import("@/views/common/Refresh"),
    meta: { frame: "Common", title: "刷新页面" }
  },
  {
    path: "/error404",
    name: "Error404",
    component: () => import("@/views/common/Error404"),
    meta: { frame: "Common", title: "错误404" }
  },
  {
    path: "/home",
    name: "Home",
    component: TheLayout,
    meta: { frame: "Common", title: "总览" },
    redirect: "/home",
    children: [
      {
        path: "index",
        name: "HomeIndex",
        component: () => import("@/views/common/HomeIndex"),
        meta: {
          frame: "Home",
          title: "总览",
          layout: 1
        }
      },
      {
        path: "upgrade",
        name: "upgrade",
        component: () => import("@/views/common/Upgrade"),
        meta: { frame: "upgrade", title: "版本升级", layout: 1 }
      },
      {
        path: "report",
        name: "report",
        component: () => import("@/views/common/Report"),
        meta: { frame: "report", title: "数据报表", layout: 1 }
      },
      {
        path: "todo",
        name: "todo",
        component: () => import("@/views/common/Todo"),
        meta: { frame: "todo", title: "待办任务", layout: 1 }
      },
      {
        path: "/fnc/notice",
        name: "notice",
        component: () => import("@/views/fnc/FncNotice"),
        meta: { frame: "notice", title: "通知", layout: 1 }
      },
      {
        path: "/fnc/notice/detail",
        name: "noticeDetail",
        component: () => import("@/views/fnc/FncNoticeDetail"),
        meta: { frame: "noticeDetail", title: "通知详情", layout: 1 }
      },
    ]
  },
  {
    path: "/",
    redirect: "/home/index"
  }
];

export default staticRoutes;
